import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AnalysisMetrics,
  toFraction,
} from '@features/dashboard/document-analysis-company/helpers/document-analysis-metrics';

@Component({
  selector: 'app-analysis-summary-cards',
  standalone: true,
  templateUrl: './analysis-summary-cards.component.html',
  styleUrls: ['./analysis-summary-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisSummaryCardsComponent {
  @Input({ required: true }) metrics!: AnalysisMetrics;

  get pendingWidth(): string {
    return this.percentWidth(this.metrics.pending);
  }

  get approvedWidth(): string {
    return this.percentWidth(this.metrics.approved);
  }

  get rejectedWidth(): string {
    return this.percentWidth(this.metrics.rejected);
  }

  private percentWidth(value: number): string {
    return `${toFraction(value, this.metrics.submitted)}%`;
  }
}
